var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20312 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 30.4348H29.3307",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7891 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9062 29.165V15.1967",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91951 12.7717C2.81064 12.8543 2.73094 12.9681 2.69157 13.0972C2.65221 13.2263 2.65515 13.3642 2.7 13.4916C2.74484 13.619 2.82933 13.7295 2.94163 13.8075C3.05394 13.8856 3.18841 13.9274 3.32622 13.927H28.6691C28.8042 13.9273 28.9361 13.887 29.0471 13.8117C29.158 13.7364 29.2427 13.6296 29.2896 13.5058C29.3365 13.382 29.3435 13.247 29.3095 13.1192C29.2755 12.9914 29.2023 12.8769 29.0996 12.7911L16.4118 2.65395C16.2962 2.55692 16.1497 2.50198 15.9974 2.49845C15.845 2.49492 15.6961 2.54302 15.5759 2.63458L2.91951 12.7717Z",
    stroke: "#1E1E20",
    strokeWidth: 2.53968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconBank);
export default __webpack_public_path__ + "static/media/gat-icon-bank.06620a5ffae29ad10a646b71f2271374.svg";
export { ForwardRef as ReactComponent };